export default {"src":"/_next/static/media/photo-fallback.41254027.svg","height":46,"width":46};